<template>
  <div class="ui left aligned container">
    <vuetable ref="vuetable"
              api-url="/baidu/index"
              :fields="fields"
              :sort-order="sortOrder"
              @vuetable:pagination-data="onPaginationData"
    >
    </vuetable>
    <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage"></vuetable-pagination>
    <div>
      <br/>
      <a href="https://index.baidu.com/v2/main/index.html#/trend/%E6%9D%A8%E8%B6%85%E8%B6%8A?words=%E6%9D%A8%E8%B6%85%E8%B6%8A" target="_blank">百度指数</a>
    </div>
    <div class="ui hidden divider"></div>
    <div class="row">
      <date-picker range valueType="format" @clear="range=[]" v-model="range"></date-picker>
      <button class="ui load button" @click="load">Load</button>
    </div>
    <v-chart id="chart" :options="options" theme="light"></v-chart>
  </div>
</template>
<style>
.ui.load.button {
  margin-left: 12px;
}
</style>
<script>
  import Vuetable from '../table/Vuetable.vue'
  import VuetablePagination from '../table/VuetablePagination.vue'
  import axios from 'axios'
  import ECharts from 'vue-echarts'
  import DatePicker from 'vue2-datepicker'

  export default {
    name: 'BaiduIndex',
    components: {
      Vuetable,
      VuetablePagination,
      DatePicker,
      'v-chart': ECharts
    },
    data () {
      return {
        fields: [
          {name: 'date', title: '日期', sortField: 'date'},
          {name: 'allIndex', title: '全部', sortField: 'allIndex'},
          {name: 'pcIndex', title: '电脑端', sortField: 'pcIndex'},
          {name: 'wiseIndex', title: '移动端', sortField: 'wiseIndex'},
        ],
        page: 0,
        range: [],
        options: null,
        sortOrder: [
          {
            field: 'date',
            direction: 'desc'
          }
        ]
      }
    },
    mounted () {
      this.load();
    },
    methods: {
      onPaginationData (paginationData) {
        this.$refs.pagination.setPaginationData(paginationData)
      },
      onChangePage (page) {
        if (page === 'prev') {
          this.page--
        } else if (page === 'next') {
          this.page++
        } else {
          this.page = parseInt(page)
        }
        this.range = [];
        this.load();
        this.$refs.vuetable.changePage(page)
      },
      load: function () {
        let api = `/baidu/index/chart?size=10&page=${this.page}`
        if (this.range.length === 2) {
          api = `/baidu/index/chart?start=${this.range[0]}&end=${this.range[1]}`
        }
        axios.get(api).then(response => {
          this.options =
            {
              title: {
                text: '数据'
              },
              tooltip: {
                trigger: 'axis'
              },
              legend: {
                data: ['全部', '电脑端', '移动端']
              },
              toolbox: {
                feature: {
                  saveAsImage: {}
                }
              },
              xAxis: {
                type: 'time'
              },
              yAxis: {
                type: 'value'
              },
              series: [
                {
                  name: '全部',
                  type: 'line',
                  data: response.data.map(e => [e.date, e.allIndex])
                },
                {
                  name: '电脑端',
                  type: 'line',
                  data: response.data.map(e => [e.date, e.pcIndex])
                },
                {
                  name: '移动端',
                  type: 'line',
                  data: response.data.map(e => [e.date, e.wiseIndex])
                },
              ]
            };
        });
      }
    }
  }
</script>
